module.exports = __webpack_public_path__ + "images/emoji/partly_sunny.fd6640665754beeb4c15.png";